import { useEffect, useRef, useState } from "react";
import PageContainer from "@components/layout/PageContainer";
import { useParams } from "react-router-dom";
import styles from "./style.module.scss";
import ModelIndex, { ModelIndexHandle } from "@components/layout/ModelIndex";
import { AtvMessageDataType } from "@/api/AtvMessageApi";
import { FetchResponse } from "@/api/ApiClient";
import moment from "moment";
import { renderEDocumentStatusOffCanvasTrigger } from "@utils/ModelIndexUtils";
import { formatMoneyValue } from "@utils/Currency";
import { ProviderNoteApi, ProviderNoteDataType } from "@/api/ProviderNoteApi";
import { ProviderNoteRelatedAttributes } from "@/formTypes/ProviderNoteFormDataType";
import { ProviderNoteFormDataKeys } from "@/generated/ProviderNoteFormDataKeys";

const AtvMessageListByInvoiceNoteId = () => {
  const params = useParams()
  const { invoiceNoteId } = params;
  const modelRef = useRef<ModelIndexHandle>(null);
  const [invoiceNoteData, setInvoiceNoteData] = useState<ProviderNoteDataType>({});

  useEffect(() => {
    loadInvoice()
  }, [invoiceNoteId]);

  const loadInvoice = async () => {
    if (invoiceNoteId) {
      const selectionSet = [
        ...ProviderNoteFormDataKeys.filter(k => !ProviderNoteRelatedAttributes.includes(k)),
        "currency.*",
        "providerInvoice.*"
      ]
      const invoiceNote = await ProviderNoteApi.get(invoiceNoteId, { selectionSet });
      setInvoiceNoteData(invoiceNote)
      setTimeout(() => {
        modelRef?.current?.refetch()
      });
    } else {
      alert("No fue posible cargar la informacion de la nota de credito/debito")
    }
  }

  const getAtvMessages = async (): Promise<FetchResponse<AtvMessageDataType>> => {
    return {
      items: invoiceNoteData?.atvMessages || []
    }
  }

  return (
    <PageContainer
      title={`Lista de Mensajes ATV de Nota Credito/Debitoo #${invoiceNoteData.sequence || ""}`}
      backUrl={`/user/provider-invoices/notes/${invoiceNoteData.providerInvoiceId}`}
    >
      <ModelIndex<AtvMessageDataType>
        ref={modelRef}
        fetchData={() => getAtvMessages()}
        primaryProperties={[
          {
            key: "sequence",
            highlighted: true,
            className: styles.sequence
          },
          {
            key: (d) => d.provider?.nombre || "",
            alignment: "Start"
          },
        ]}
        primaryPropertiesSizing={
          [
            { sm: "4", xs: "12" },
            { sm: "8", xs: "12" }
          ]
        }
        secondaryProperties={[
          {
            key: (data) => {
              const date = moment(data.createdAt, "YYYY-MM-DD")
              return date.format("DD-MM-YYYY")
            },
            title: "Fecha",
          },
          {
            key: (data) => renderEDocumentStatusOffCanvasTrigger(data),
            title: "Estado ATV"
          },
          {
            key: (data) => {
              return formatMoneyValue(data.totalFactura, 1)
            },
            title: "Total",
            highlighted: true
          }
        ]}
        secondaryPropertiesSizing={
          [
            { sm: "4", md: "2" },
            { sm: "4", md: "3" },
            { sm: "4", md: "2" }
          ]
        }
      >
      </ModelIndex>
    </PageContainer >
  );
}

export default AtvMessageListByInvoiceNoteId;
